export default __webpack_public_path__ + "static/media/09_tag_spa.90d6341d.svg";